'use client';
import { useState } from 'react';
import styles from './Header.module.css';
import Hamburger from 'hamburger-react';
import Link from 'next/link';
import { UserPlus, LogIn } from 'lucide-react';
import { Button } from '../ui/button';

export const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="relative z-10 bg-black bg-opacity-30">
      <nav className={`${styles.navContainer} max-w-screen-2xl mx-auto`}>
        <div className="flex items-center mr-8">
          <Link href="/" className={styles.logo}>
            JimGym
          </Link>
        </div>

        <ul
          className={`${styles.navList} ${
            isMobileMenuOpen ? styles.active : ''
          }`}
        >
          <li className={styles.listItem}>
            <a href="#features" className={styles.listItemLink}>
              Features
            </a>
          </li>
          <li className={styles.listItem}>
            <a href="#pricing" className={styles.listItemLink}>
              Pricing
            </a>
          </li>
          <li className={styles.listItem}>
            <a href="#testimonials" className={styles.listItemLink}>
              Testimonials
            </a>
          </li>
          <li className={styles.listItem}>
            <a href="#contact-us" className={styles.listItemLink}>
              Contact Us
            </a>
          </li>
          <li className="ml-auto md:ml-auto md:mb-0 mb-2 w-full px-4 md:w-auto md:px-0">
            <Link href="/auth/signup" passHref>
              <Button className="w-full sm:w-auto text-base font-semibold py-5 px-6 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] hover:from-[var(--primary-dark)] hover:to-[var(--secondary-dark)] text-white transition-all duration-300 ease-in-out transform hover:scale-105 shadow-lg rounded-full">
                <UserPlus className="mr-2 h-5 w-5" />
                Sign Up Free
              </Button>
            </Link>
          </li>
          <li className="md:ml-4 mb-4 md:mb-0 w-full px-4 md:w-auto md:px-0">
            <Link href="/auth/signin" passHref>
              <Button
                variant="outline"
                className="w-full sm:w-auto text-base font-semibold py-5 px-6 bg-transparent border border-white/20 text-white hover:bg-white/10 transition-all duration-300 ease-in-out transform hover:scale-105 rounded-full"
              >
                <LogIn className="mr-2 h-5 w-5" />
                Sign In
              </Button>
            </Link>
          </li>
        </ul>
        <div className={styles.hamburger}>
          <Hamburger
            color="white"
            toggled={isMobileMenuOpen}
            toggle={toggleMobileMenu}
            label="Show menu"
            size={24}
          />
        </div>
      </nav>
    </header>
  );
};
